import { NO_CAPTCHA_REQUIRED_STATUS } from 'src/dataLayer/localData/captcha'
import { reportCaptchaError } from 'src/dataLayer/remoteData/rollbar'

const isCaptchaRequired = (captchaResponseToken) =>
  !(captchaResponseToken === NO_CAPTCHA_REQUIRED_STATUS)

export const formatCaptchaResult = (captchaResponseToken) => {
  if (!captchaResponseToken) {
    reportCaptchaError('captchaResponseToken was missing on auth token request', {})
    // eslint-disable-next-line no-throw-literal -- error keys are strings by convention
    throw 'common.error.unknown'
  }
  return isCaptchaRequired(captchaResponseToken) ? { response: captchaResponseToken } : {}
}
